import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/AuthProvider";


export default function Protected(){
   const { estaLogueado } = useAuth();
   
    if (!estaLogueado){
        return <Navigate to="login" replace/>
    }

    return <Outlet />


}